import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGoogleLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.20801 9.99967C3.20801 5.97288 6.47195 2.70801 10.4997 2.70801C12.2752 2.70801 13.9023 3.34484 15.1668 4.39977C15.4318 4.62089 15.4673 5.01502 15.2463 5.28006C15.0251 5.54511 14.631 5.58072 14.3659 5.35958C13.3171 4.48451 11.9708 3.95801 10.4997 3.95801C7.1624 3.95801 4.45801 6.66313 4.45801 9.99967C4.45801 13.337 7.16235 16.0413 10.4997 16.0413C13.6253 16.0413 16.1967 13.6682 16.5094 10.6247H11.333C10.9878 10.6247 10.708 10.3448 10.708 9.99967C10.708 9.65451 10.9878 9.37467 11.333 9.37467H17.1663C17.5115 9.37467 17.7913 9.65451 17.7913 9.99967C17.7913 14.0274 14.5265 17.2913 10.4997 17.2913C6.472 17.2913 3.20801 14.0273 3.20801 9.99967Z",
		fill: "currentColor"
	})
});
export default SvgGoogleLine;
